import { jsx as a, jsxs as g } from "react/jsx-runtime";
import { Tooltip as c } from "@systemeio/ui";
import { useEditorState as A } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useMemo as N } from "react";
import { twMerge as e } from "tailwind-merge";
import { ToolbarButton as b } from "../../components/content-controls/toolbar-button.mjs";
import { TOOLTIP_STYLES as f, getToolbarIconClassName as p, TOOLBAR_BUTTON_CLASSNAMES as u } from "../../constants/default-styles.mjs";
import { getShortcut as d, rawShortcuts as L } from "../../utils/get-shortcuts.mjs";
import { setList as h, getListIcon as E } from "./utils/list.mjs";
import { useTranslation as I } from "../../i18n.mjs";
const _ = (n, s) => {
  const { t: i } = I(), t = A({
    editor: n,
    selector: ({ editor: o }) => ({
      isEditable: (o == null ? void 0 : o.options.editable) ?? !1,
      isActive: (o == null ? void 0 : o.isActive(s)) ?? !1
    })
  }), r = !(t != null && t.isEditable), l = t == null ? void 0 : t.isActive;
  return N(() => {
    const o = () => h({ editor: n, listType: s }), m = E({ listType: s });
    return {
      toolbarRender: /* @__PURE__ */ a(
        c,
        {
          disabled: r,
          label: `${i(`${s}`)} (${d(L.list[s])})`,
          ...f,
          children: /* @__PURE__ */ a(
            b,
            {
              disabled: r,
              className: e(
                u,
                l && "bg-brand-primary/10",
                "main-transition-colors"
              ),
              onClick: o,
              children: /* @__PURE__ */ a(m, { className: p(r) })
            }
          )
        }
      ),
      tooltipRender: /* @__PURE__ */ a(
        c,
        {
          disabled: r,
          label: d(L.list[s]),
          ...f,
          children: /* @__PURE__ */ g(
            b,
            {
              disabled: r,
              className: e(
                u,
                l && "bg-brand-primary/10",
                "main-transition-colors",
                "flex gap-1"
              ),
              onClick: o,
              children: [
                /* @__PURE__ */ a(m, { className: p(r) }),
                i(`${s}`)
              ]
            }
          )
        }
      )
    };
  }, [n, l, r, s, i]);
};
export {
  _ as useListExtensionToolbar
};
